<form [formGroup]="maintenanceEntryForm">
  @for (column of columns; track column) {
    <div class="input-height">
      <geaui-input-v3
        [id]="column.name"
        [required]="column.required"
        [formGroup]="maintenanceEntryForm"
        [formFieldName]="column.name"
        [label]="column.header"
        floatLabelType="auto">
      </geaui-input-v3>
    </div>
  }
</form>
